module.exports = __webpack_public_path__ + "static/media/8.e4b5bb90.svg";